/**
 * Legal headings link icons
 * Adds clickable link icons to .legal-heading elements for section linking
 */

main.initLegalHeadings = function() {
  document.querySelectorAll('.legal-heading').forEach(function(heading) {
    const id = heading.getAttribute('id');
    if (id) {
      const linkIcon = document.createElement('a');
      linkIcon.href = '#' + id;
      linkIcon.className = 'link-icon';
      linkIcon.innerHTML = '<i class="bi bi-link-45deg"></i>';
      linkIcon.setAttribute('aria-label', 'Link to this section');

      // Copy link to clipboard on click
      linkIcon.addEventListener('click', function(e) {
        e.preventDefault();
        const url = window.location.origin + window.location.pathname + '#' + id;
        navigator.clipboard.writeText(url).then(function() {
          // Update URL without scrolling
          history.pushState(null, null, '#' + id);

          // Show feedback
          const originalIcon = linkIcon.innerHTML;
          linkIcon.innerHTML = '<i class="bi bi-check"></i>';
          setTimeout(function() {
            linkIcon.innerHTML = originalIcon;
          }, 1000);
        });
      });

      heading.insertBefore(linkIcon, heading.firstChild);
    }
  });
}
